import type { CampaignQuoteItemModel } from '@models/types'

const paidByKeys = [
  'agency',
  'agent',
  'commission',
  'vendor',
] as const

export type PaidByKey = typeof paidByKeys[number]

type PaidByOption = {
  key: PaidByKey,
  text: string,
}

export const paidByOptions: PaidByOption[] = [
  { key: 'agency', text: 'Paid by Agency' },
  { key: 'agent', text: 'Paid by Agent' },
  { key: 'commission', text: 'Paid from Commission' },
  { key: 'vendor', text: 'Paid by Vendor' },
]

type QuoteItemHiddenTextParams = {
  hideDates: boolean,
  hidePrices: boolean,
}

export const quoteItemSettingsHiddenText = (params: QuoteItemHiddenTextParams) => {
  const { hideDates, hidePrices } = params

  if (hideDates && hidePrices){
    return 'Prices and Dates will not display.'
  }

  if (hideDates){
    return 'Dates will not display.'
  }

  if (hidePrices){
    return 'Prices will not display.'
  }

  return undefined
}

type ItemRequiresExternalManagementParams = {
  campaignQuoteItem: CampaignQuoteItemModel | {},
}

export function itemRequiresExternalManagement(params: ItemRequiresExternalManagementParams) {
  const { campaignQuoteItem } = params
  // @ts-expect-error TS2339
  return !!campaignQuoteItem.deep_link_url || false
}